import React from 'react';
import { useSwipe, getSwipeStyle, getSwipeIndicator } from '../../hooks/useSwipe';

interface SwipeableCardProps {
  children: React.ReactNode;
  onApprove?: () => void;
  onReject?: () => void;
  disabled?: boolean;
}

/**
 * 스와이프 가능한 카드
 * 오른쪽 → 승인, 왼쪽 → 거절
 */
export const SwipeableCard: React.FC<SwipeableCardProps> = ({
  children,
  onApprove,
  onReject,
  disabled = false,
}) => {
  const { handlers, isSwiping, swipeDistance } = useSwipe({
    onSwipeRight: onApprove,
    onSwipeLeft: onReject,
    threshold: 100,
  });

  const indicator = getSwipeIndicator(swipeDistance, 100);

  if (disabled) {
    return <div>{children}</div>;
  }

  return (
    <div className="relative overflow-hidden">
      {/* 배경 표시기 */}
      {indicator && (
        <>
          {indicator.direction === 'right' && onApprove && (
            <div
              className="absolute inset-y-0 left-0 flex items-center justify-start pl-6 bg-gradient-to-r from-purple-100 to-pink-100"
              style={{ opacity: indicator.opacity, width: '100%' }}
            >
              <span className="text-5xl">🎰</span>
              <span className="ml-3 font-bold text-purple-700 text-xl">추첨 시작</span>
            </div>
          )}
          {indicator.direction === 'left' && onReject && (
            <div
              className="absolute inset-y-0 right-0 flex items-center justify-end pr-6 bg-red-100"
              style={{ opacity: indicator.opacity, width: '100%' }}
            >
              <span className="mr-3 font-bold text-red-700 text-xl">거절</span>
              <span className="text-5xl">{indicator.icon}</span>
            </div>
          )}
        </>
      )}

      {/* 스와이프 가능한 카드 */}
      <div
        {...handlers}
        style={getSwipeStyle(swipeDistance)}
        className="relative bg-white touch-pan-y"
      >
        {children}
      </div>

      {/* 스와이프 힌트 (첫 사용 시) */}
      {!isSwiping && swipeDistance === 0 && onApprove && (
        <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 text-xs text-gray-400 pointer-events-none animate-pulse">
          ← 스와이프해서 추첨 →
        </div>
      )}
    </div>
  );
};
